<template>
  <v-switch
    v-model="closedFilter"
    :label="$t('chat.filterClosed')"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-closedFilter',
  computed: {
    ...mapGetters({
      closed: 'chat/ChannelsFilters/closed'
    }),
    closedFilter: {
      get () { return this.closed },
      set (closed) { this.setClosed(closed) }
    }
  },
  methods: {
    ...mapActions({
      setClosed: 'chat/ChannelsFilters/filterClosed'
    })
  }
}
</script>

<style>

</style>
